import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Building2, ChevronDown } from "lucide-react";

export default function TenantSwitcher({ className = "" }) {
  const [tenants, setTenants] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/my-tenants")
      .then((r) => setTenants(Array.isArray(r.data) ? r.data : []))
      .catch(() => setTenants([]));
  }, []);

  if (tenants.length < 2) return null;
  const current = tenants.find((t) => t.current) || tenants[0];

  const onChange = async (e) => {
    const tid = e.target.value;
    if (!tid || tid === current?.id || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/auth/switch-tenant", { tenant_id: tid });
      localStorage.setItem("sw_token", data.token);
      localStorage.removeItem("sw_perms");
      window.location.href = "/app/dashboard";
    } catch {
      setBusy(false);
    }
  };

  return (
    <div className={`relative ${className}`} data-testid="tenant-switcher">
      <Building2 size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[#94a3b8] pointer-events-none" />
      <select
        value={current?.id}
        onChange={onChange}
        disabled={busy}
        data-testid="tenant-switcher-select"
        className="w-full appearance-none pl-8 pr-7 py-1.5 rounded-[10px] border border-[#e2e8f0] bg-[#f8fafc] text-[12.5px] font-medium text-[#1e293b] cursor-pointer focus:outline-none focus:border-[#94a3b8]"
      >
        {tenants.map((t) => (
          <option key={t.id} value={t.id}>
            {(t.short_name || t.name)}{t.home ? "" : " ⇄"}
          </option>
        ))}
      </select>
      <ChevronDown size={13} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#94a3b8] pointer-events-none" />
    </div>
  );
}
